import {AppForm} from "../../../../../../../common/forms/app.form";
import {Injectable} from "@angular/core";
import {FormControl, Validators} from "@angular/forms";
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ParcelAppEntityParcelWrite
} from "../../../../../../../openapi";

@Injectable()
export class PerpetualUsufructBaseInfoForm extends AppForm {
  constructor() {
    super({
      parcels: new FormControl<ParcelAppEntityParcelWrite[]>([], {
        nonNullable: true,
        validators: [Validators.required, Validators.minLength(1)]
      }),
      city: new FormControl('', {nonNullable: true, validators: [Validators.required, Validators.maxLength(255)]}),
      street: new FormControl('', {nonNullable: true, validators: [Validators.required, Validators.maxLength(255)]}),
    });
  }

  public get parcels(): FormControl {
    return this.get('parcels') as FormControl;
  }

  public get parcelsValues(): ParcelAppEntityParcelWrite[] {
    return this.parcels.value;
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    const value = this.value;
    delete value.parcels;
    return value;
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchValue({
      ...value
    });
    if (!!value.parcels?.length) {
      this.parcels.setValue(value.parcels);
    }
  }
}
